import { useState } from 'react';
import {
  CustomDialog,
  AutoCompleteController,
  Button,
} from '../../components';
import { downLoadLink } from '../../utils/functions/common';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import * as yup from 'yup';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import { useGetAllEnterpriseQuery } from '../../services/common';
import { useLazyExportCommissionsQuery } from '../../services/commission';

const formSchema = yup.object({
  enterprise: yup.number().required(),
});
type TFormData = yup.InferType<typeof formSchema>;

export const CommissionExport: React.FC = () => {
  const { data: listOfEnterprises } =
    useGetAllEnterpriseQuery([1]);
  const formattedListOfEnterprises = listOfEnterprises?.map(
    (ele) => ({
      value: ele.id,
      label: ele.companyName,
    })
  );

  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const dispatch = useAppDispatch();
  const [exportCommissions] =
    useLazyExportCommissionsQuery();
  const [open, setOpen] = useState(false);

  const onExportClick = (data: TFormData) => {
    exportCommissions({
      enterpriseId: data.enterprise,
    })
      .unwrap()
      .then((res) => {
        downLoadLink(res.url);
        dispatch(
          showAlert({
            content: res.url
              ? 'Commissions Exported Successfully'
              : 'No data found with applied conditions',
            severity: res.url ? 'success' : 'error',
          })
        );
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-2"
        variant="button--secondary">
        Export
      </Button>
      <CustomDialog
        dialogTitle={'Commission Export'}
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit((data) =>
          onExportClick(data)
        )}
        actionText={{ submit: 'Export', cancel: 'Cancel' }}
        maxWidth="sm">
        <form
          onSubmit={handleSubmit((data) =>
            onExportClick(data)
          )}
          className="mb-10 pb-20">
          <AutoCompleteController
            label="Enterprise"
            name="enterprise"
            control={control}
            options={formattedListOfEnterprises}
            error={errors.enterprise?.message}
            required
          />
        </form>
      </CustomDialog>
    </>
  );
};
